/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as TYPES from './action-types';
const intialState = {
  beginQtr: '',
  endQtr: '',
  rebateCD: '',
  planType: '',
  gridData: {},
  maxFrozenQtr: null,
  errorMessages: [],
};

const reducer = (state = intialState, action) => {
  switch (action.type) {
    case TYPES.QUARTERlY_MARKETING_BEGQTR:
      return { ...state, beginQtr: action.payload };
    case TYPES.QUARTERlY_MARKETING_ENDQTR:
      return { ...state, endQtr: action.payload };
    case TYPES.QUARTERlY_MARKETING_REBATE_CD:
      return { ...state, rebateCD: action.payload };
    case TYPES.QUARTERlY_MARKETING_PLAN_TYPE:
      return { ...state, planType: action.payload };
    case TYPES.QUARTERlY_MARKETING_GRID_DATA:
      return { ...state, gridData: action.payload };
    case TYPES.SET_ERROR_MESSAGES:
      return { ...state, errorMessages: action.payload };
    case TYPES.SET_MAX_FROZEN_QTR:
      return { ...state, maxFrozenQtr: action.payload };
    case TYPES.RESET_QUARTERLY_MARKETIING_STORE:
      return { ...intialState };
    default:
      return { ...state };
  }
};

export default reducer;
